<template>
  <!-- <div v-if="isFlagIcon" class="flag-icon-wrap"> -->
  <div class="flag-icon-wrap">
    <div v-for="(item, index) in list" :key="index" class="icon" :class="(item.locale === locale) ? 'active' : ''" @click="tab(index)">
      <img :src="require(`@/assets/img/${item.icon}.svg`)"/>
    </div>
  </div>
  <!-- <div v-else class="language_bar">
    <div
      class="lang_text"
      v-for="(item, index) in list"
      :key="index"
      :class="item.locale === locale ? 'active' : ''"
      @click="tab(index)"
    >{{ item.name }}</div>
  </div> -->
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'LanguageBar',
  // props: {
  //   isFlagIcon: { type: Boolean, default: false }
  // },
  data () {
    return {
      list: [
        {
          name: '한국어',
          locale: 'ko',
          icon: 'flag_kor'
        },
        {
          name: 'English',
          locale: 'en',
          icon: 'flag_usa'
        },
        {
          name: '日本',
          locale: 'jp',
          icon: 'flag_jpn'
        },
        {
          name: '中文(简体)',
          locale: 'cn_simplified',
          icon: 'flag_chn'
        }
      ]
    }
  },
  computed: {
    ...mapState(['restaurant']),
    locale () {
      return this.$store.state.locale
    }
  },
  mounted () {
    // 홈화면 왔을떄 한국어로 초기화
    this.$store.commit('locale', 'ko')
    this.$i18n.locale = 'ko'
    this.changeMenuRequired()
  },
  methods: {
    changeMenuRequired () {
      const menuRequired = ((this.$i18n.locale !== 'ko') && this.restaurant.isNumTicket) ? false : localStorage.getItem('menuRequired') === 'true'
      this.$store.commit('restaurant', { menuRequired })
    },
    tab (index) {
      this.active = index
      this.$i18n.locale = this.list[index].locale
      this.$store.commit('locale', this.$i18n.locale)
      this.changeMenuRequired()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/base.scss";
.flag-icon-wrap {
  display: flex;
  max-width: 42.96875vw;
  padding: 0.75vh;
  align-items: flex-start;
  border-radius: 2vh;
  background: #2E3137;
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10.546875vw;
    height: 5.6875vh;
    &.active {
      border-radius: 1.75vh;
      background: #FFF;
    }
  }
}
/* .language_bar {
  display: flex;
  width: 100%;
  height: 56px;
  border-radius: 45px;
  border: solid 3px $white;
  .lang_text {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 189px;
    height: 100%;
    border-radius: 45px;
    font-size: 27px;
    font-weight: bold;
    color: $white;
    &.active {
      background: $white;
      color: $select;
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.flag-icon-wrap {
  display: flex;
  padding: 8px;
  border-radius: 12px;
  background: $gray_800;
  .icon {
    width: 115px;
    height: 40px;
    padding: 8px 0;
    margin: 0 8px 0 0;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    &.active {
      background: $white;
      box-shadow: 0px 4px 4px rgba(19, 21, 23, 0.25);
    }
    &:last-child {
      margin: 0;
    }
  }
} */
</style>
